import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withSelectedCategoryId from '../../../HOC/withSelectedCategoryId/withSelectedCategoryId';
import { selectPathToSelectedCategory } from '../../../selectors/categoriesSelectors';
import styles from './Breadcrumbs.module.css';

const staticCategoryNames = ['All', 'My Cart', 'My Favorites', 'Free Gift!'];

function Breadcrumbs(props) {
  const { pathToSelectedCategory } = props;
  const isPathToStaticCategory = staticCategoryNames.includes(
    pathToSelectedCategory[0]
  );
  const formattedPathToSelectedCategory = isPathToStaticCategory
    ? pathToSelectedCategory
    : ['All', ...pathToSelectedCategory];

  return (
    <ul className={styles.breadcrumbs}>
      {formattedPathToSelectedCategory.map((categoryName, i) => {
        const isLastCategoryName =
          i === formattedPathToSelectedCategory.length - 1;
        return (
          <React.Fragment key={categoryName}>
            <li className={isLastCategoryName ? styles.selectedCategory : ''}>
              {categoryName}
            </li>
            {!isLastCategoryName && <li>/</li>}
          </React.Fragment>
        );
      })}
    </ul>
  );
}

function mapStateToProps(state, props) {
  return {
    pathToSelectedCategory: selectPathToSelectedCategory(state, props),
  };
}

export default compose(
  withSelectedCategoryId,
  connect(mapStateToProps)
)(Breadcrumbs);
